import { useEffect } from 'react';

const APP_URL = 'https://memocal.app';

export default function LandingPage() {
  useEffect(() => {
    const api = encodeURIComponent(process.env.REACT_APP_API_URL || 'http://localhost:10000');
    const app = encodeURIComponent(APP_URL);
    window.location.replace(`/landing.html?api=${api}&app=${app}`);
  }, []);

  return null;
}
